import {Modal, TextField, Typography} from "@mui/material";
import {Box} from "@mui/system";
import noSettingImage from "../../../assets/img/recommended/noSetting.svg";
import {COLORS} from "../../../ui/Theme";
import {toast} from "react-toastify";
import {ERROR_STATUS} from "../../../status/status";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {sendData} from "../../../lib/dashboard/actions";
import React from "react";
import {mutate} from "swr";
import Loading from "../../../components/loader/Loading";

const RecommendedSettingAddSettingModal = ({openAddModal, handleCloseAddModal}) => {

    const {
        config,
        configNewName,
        setConfigNewName,
    } = useRecommendedContext();

    //CREATE SETTING NAME
    const handleAddSettingName = async (e) => {

        e.preventDefault();
        if (!configNewName.trim()) {
            toast(ERROR_STATUS.INPUT, {type: "error"});
            return;
        }

        await sendData({name: configNewName}, "/stock-market/v2/recomm-config");
        await Promise.all([
            mutate("/stock-market/v2/recomm-config"),
            mutate("/stock-market/recommended"),
        ])
        setConfigNewName("")
        handleCloseAddModal();
    };

    const style = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "20px",
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "12px",
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    return (
        <Modal
            open={openAddModal}
            onClose={handleCloseAddModal}
        >
            <Box sx={style}>
                <img width="300px" src={noSettingImage} alt="settingImage"/>
                <form
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: "20px",
                        width: "100%",
                    }}
                    onSubmit={handleAddSettingName}
                >
                    <Typography sx={{fontSize: "24px", fontWeight: "bold", color: COLORS.BLACK}}>
                        تنظیمات خود را بسازید
                    </Typography>
                    <TextField
                        value={configNewName}
                        onChange={(e) => setConfigNewName(e.target.value)}
                        placeholder="نام تنظیمات"
                    />
                    <button
                        disabled={config.isValidating}
                        type="submit"
                        style={{
                            justifyContent: "center",
                            cursor: config.isValidating ? "default" : "pointer",
                        }}
                        className="btn btn-blue"
                    >
                        {
                            config.isValidating
                                ?
                                <Loading
                                    size="11px"
                                    color={COLORS.WHITE}
                                />
                                :
                                <>
                                    ثبت و ادامه
                                    <KeyboardArrowLeftIcon/>
                                </>
                        }
                    </button>
                </form>
            </Box>
        </Modal>
    );
};

export default RecommendedSettingAddSettingModal;